// Only the new bulk-messaging workflow uses this rollout restriction.
// Existing Receipt Review and Docket emails retain their own access checks.
// The server remains authoritative at confirmation/dispatch.
export const canSendBulkCommunications = (accessLevel) => (
  typeof accessLevel === 'string' && accessLevel.trim().toLowerCase() === 'global admin'
);
